import Card from "./Card";

export default Card;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Card/index.tsx